import { stringify } from 'qs';
import { Api as apiService } from '../api';
export class AggregationCountsApi {
    static loadAggregationCounts(match, params) {
        const query = stringify(params);
        return apiService
            .get(AggregationCountsApi.aggregationCountsURL + `/${match}/count?${query}`)
            .then((response) => response.json());
    }
}
AggregationCountsApi.aggregationCountsURL = '/api/web/transactions/aggregation';
